import type { OfficeRole } from '@relay-towing/api';

export type TabId =
  | 'home'
  | 'drivers'
  | 'calls'
  | 'impounds'
  | 'invoices'
  | 'inspections'
  | 'scanner'
  | 'analytics';

/**
 * The two fixed sets of tabs the app had before office roles, kept so the
 * release that brought them in did not change what anyone sees here. The
 * tabs were briefly worked out from the Roles page checkboxes instead, and
 * a new owner, who also drives, got both sets: eight tabs where they had
 * six. What a role may do inside a tab is still the server's to decide.
 */
const OFFICE_TABS: readonly TabId[] = [
  'home',
  'drivers',
  'impounds',
  'invoices',
  'inspections',
  'analytics',
];

const FIELD_TABS: readonly TabId[] = [
  'calls',
  'impounds',
  'invoices',
  'inspections',
  'scanner',
];

/**
 * The tabs a member sees: the office set for any office role, whether or
 * not they drive, and the field set for someone who only drives.
 */
export function tabsFor({
  officeRole,
  drives,
}: {
  officeRole: OfficeRole | null;
  drives: boolean;
}): TabId[] {
  if (officeRole) return [...OFFICE_TABS];
  return drives ? [...FIELD_TABS] : [];
}

/** The tab to open: the one asked for if it is shown, else the first. */
export function initialTab(tabs: readonly TabId[], preferred?: string): TabId {
  const asked = tabs.find((tab) => tab === preferred);
  return asked ?? tabs[0] ?? 'calls';
}
